import React from "react";

export default function BsTelephone() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#currentColor"
        d="M5.48 2.075A1.017 1.017 0 0 0 3.96 1.98L2.408 3.53c-.726.726-.992 1.754-.675 2.655a26.352 26.352 0 0 0 6.251 9.913 26.351 26.351 0 0 0 9.913 6.251c.902.317 1.929.05 2.654-.675l1.551-1.55a1.017 1.017 0 0 0-.095-1.523l-3.459-2.69a1.017 1.017 0 0 0-.871-.184l-3.284.82a2.617 2.617 0 0 1-2.485-.688l-3.685-3.685a2.617 2.617 0 0 1-.689-2.485l.821-3.284a1.017 1.017 0 0 0-.184-.871l-2.69-3.46ZM2.828.849a2.617 2.617 0 0 1 3.917.243l2.69 3.46c.494.635.668 1.461.473 2.241l-.82 3.284c-.087.347.014.713.267.966l3.685 3.685c.253.253.62.354.966.268l3.284-.821a2.617 2.617 0 0 1 2.241.473l3.46 2.69a2.617 2.617 0 0 1 .243 3.917l-1.55 1.55c-1.11 1.11-2.77 1.598-4.316 1.054a27.952 27.952 0 0 1-10.514-6.63A27.951 27.951 0 0 1 .223 6.715C-.32 5.17.167 3.51 1.276 2.4L2.827.849Z"
      />
    </svg>
  );
}
